
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'AppRadioButton',
  props: {
    modelValue: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, context) {
    const picked = computed({
      get: () => props.modelValue,
      set: (val) => {
        context.emit('update:modelValue', val)
      },
    })
    return {
      picked,
    }
  },
})
